<template>
  <div class="text" :class="{
    'text--center': center,
    'text--small': small,
    'text--big': big,
  }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VText',

  props: {
    center: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    big: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-family: 'Antonio', Arial, Helvetica, sans-serif;
  font-size: font(18px, 26px);
  line-height: 1.25em;

  &:not(:first-child) {
    margin-top: 25px;
  }

  a {
    color: inherit;
    text-decoration: none;

    border-bottom: 1px solid #000000;

    &:hover {
      color: #550f77;
      border-bottom: 1px solid #550f77;
    }
  }

  span {
    color: #550f77;
  }

  &--center {
    text-align: center;
  }

  &--small {
    font-size: font(18px, 22px);
    line-height: 1.25em;
  }

  &--big {
    font-size: font(18px, 49px);
    line-height: 1.25em;
  }
}
</style>
